export const inviteConstants = {
  INVITE_NON_WP_MEMBERS_REQUEST: 'INVITE/INVITE_NON_WP_MEMBERS_REQUEST',
  INVITE_NON_WP_MEMBERS_SUCCESS: 'INVITE/INVITE_NON_WP_MEMBERS_SUCCESS',
  INVITE_NON_WP_MEMBERS_FAILURE: 'INVITE/INVITE_NON_WP_MEMBERS_FAILURE',

  INVITE_TO_WORKPLACE_REQUEST: 'INVITE/INVITE_TO_WORKPLACE_REQUEST',
  INVITE_TO_WORKPLACE_SUCCESS: 'INVITE/INVITE_TO_WORKPLACE_SUCCESS',
  INVITE_TO_WORKPLACE_FAILURE: 'INVITE/INVITE_TO_WORKPLACE_FAILURE',
}
